export const pagePlacements = [
    { label: 'Top', value: 'top' },
    { label: 'Top fixed', value: 'top_fixed' },
    { label: 'Bottom fixed', value: 'bottom_fixed' },
    {
        label: 'Under "Add To Cart" Button',
        value: 'add_to_cart',
    },
];

export const pagesToSelect = [
    { label: 'Home', value: 'home' },
    { label: 'Collections', value: 'collections' },
    { label: 'Collection', value: 'collection' },
    { label: 'Products', value: 'product' },
    { label: 'Search', value: 'search' },
    { label: 'Cart', value: 'cart' },
    { label: 'Contact', value: 'contact' },
];
